import { render, staticRenderFns } from "./notiNotas.vue?vue&type=template&id=49720a86&scoped=true&"
import script from "./notiNotas.vue?vue&type=script&lang=js&"
export * from "./notiNotas.vue?vue&type=script&lang=js&"
import style0 from "./notiNotas.vue?vue&type=style&index=0&id=49720a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49720a86",
  null
  
)

export default component.exports